import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, numberComparatorMax3, createNumberFormatter } from "@icarius-table/number";

export default () => [
    {
        pages: [paths.vacations, "vacationsPE"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "code",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.vacations, "vacationsPE"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.vacations, "vacationsPE"],
        config: {
            headerName: getLocalizedString("state"),
            field: "ESTADO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.vacations, "vacationsPE"],
        config: {
            headerName: getLocalizedString("functionaryTypePlant"),
            field: "PERSONAL DE PLANTA",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.vacations],
        config:
        {
            headerName: getLocalizedString("earnedLegalAndOthers"),
            field: "creditLegal",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacations],
        config:
        {
            headerName: getLocalizedString("earnedAdditionalOrProgressive"),
            field: "creditAditional",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacations, "vacationsPE"],
        config:
        {
            headerName: getLocalizedString("totalEarnedDays"),
            field: "creditTotal",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacations],
        config:
        {
            headerName: getLocalizedString("legalAndOtherUsed"),
            field: "debitUsedLegal",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacations],
        config:
        {
            headerName: getLocalizedString("usedAdditionalOrProgressive"),
            field: "debitUsedAditional",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacations, "vacationsPE"],
        config:
        {
            headerName: getLocalizedString("totalUsedDays"),
            field: "debitUsedTotal",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacations],
        config:
        {
            headerName: getLocalizedString("toBeUsedInTheFutureLegalAndOthers"),
            field: "creditUnusedLegal",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacations],
        config:
        {
            headerName: getLocalizedString("toUseInFutureAdditionalOrProgressive"),
            field: "creditUnusedAditional",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacations, "vacationsPE"],
        config:
        {
            headerName: getLocalizedString("totalDaysToBeUsedInTheFuture"),
            field: "creditUnusedTotal",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacations],
        config:
        {
            headerName: getLocalizedString("legalAndOtherBalance"),
            field: "debitAvailableLegal",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacations],
        config:
        {
            headerName: getLocalizedString("debitAvailableAditional"),
            field: "debitAvailableAditional",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacations, "vacationsPE"],
        config:
        {
            headerName: getLocalizedString("debitAvailableTotalToRequest"),
            field: "debitAvailableTotalToRequest",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["vacationsPE"],
        config:
        {
            headerName: getLocalizedString("totalTruncated"),
            field: "truncated",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["vacationsPE"],
        config:
        {
            headerName: getLocalizedString("totalPending"),
            field: "pending",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["vacationsPE"],
        config:
        {
            headerName: getLocalizedString("totalOverdue"),
            field: "expired",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacations, "vacationsPE"],
        config:
        {
            headerName: getLocalizedString("debitAvailableTotalIfFired"),
            field: "debitAvailableTotalIfFired",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacations, "vacationsPE"],
        config: {
            headerName: getLocalizedString("fType"),
            field: "functionaryType",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.vacations, "vacationsPE"],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "contractType",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.vacations, "vacationsPE"],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: 'workplace',
            filter: 'agSetColumnFilter',
        }
    },
    {
        pages: [paths.vacations, "vacationsPE"],
        config: {
            headerName: getLocalizedString("filterObra o Faena"),
            field: "workOrTask",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.vacations, "vacationsPE"],
        config: {
            headerName: getLocalizedString("management"),
            field: "management",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.vacations, "vacationsPE"],
        config: {
            headerName: getLocalizedString("department"),
            field: "department",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.vacations, "vacationsPE"],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: 'costCenter',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.vacations, "vacationsPE"],
        config: {
            headerName: getLocalizedString("position"),
            field: "position",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.vacations, "vacationsPE"],
        config: {
            headerName: getLocalizedString("function"),
            field: "function",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.vacations, "vacationsPE"],
        config: {
            headerName: getLocalizedString("vacationsUpdateDate"),
            field: 'vacationsUpdateDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },

    // vacationsDetailCredit
    {
        pages: [paths.vacationsDetailCredit, "vacationsPEDetailCredit"],
        config:
        {
            headerName: getLocalizedString("year"),
            field: "year",
            filter: "agTextColumnFilter",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.vacationsDetailCredit, "vacationsPEDetailCredit"],
        config:
        {
            headerName: getLocalizedString("month"),
            field: "months",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.vacationsDetailCredit, "vacationsPEDetailCredit"],
        config:
        {
            headerName: getLocalizedString("legalDays"),
            field: "legal_days",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax3,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 3),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacationsDetailCredit],
        config:
        {
            headerName: getLocalizedString("additionalDays"),
            field: "additional_days",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax3,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 3),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacationsDetailCredit, "vacationsPEDetailCredit"],
        config:
        {
            headerName: getLocalizedString("otherDays"),
            field: "other_days",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax3,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 3),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacationsDetailCredit, "vacationsPEDetailCredit"],
        config:
        {
            headerName: getLocalizedString("total"),
            field: "total",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax3,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 3),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacationsDetailCredit, "vacationsPEDetailCredit"],
        config:
        {
            headerName: getLocalizedString("description"),
            field: "description",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.vacationsDetailCredit, "vacationsPEDetailCredit"],
        config:
        {
            headerName: getLocalizedString("usedLegalDays"),
            field: "used_legal_days",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax3,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 3),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacationsDetailCredit],
        config:
        {
            headerName: getLocalizedString("usedAdditionalDays"),
            field: "used_additional_days",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax3,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 3),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacationsDetailCredit],
        config:
        {
            headerName: getLocalizedString("pendingDays"),
            field: "pending_days",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax3,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 3),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ["vacationsPEDetailCredit"],
        config:
        {
            headerName: getLocalizedString("availableDays"),
            field: "pending_days",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax3,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 3),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacationsDetailDebit],
        config: {
            headerName: getLocalizedString("startDate"),
            field: "start_date",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            checkboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
            cellRenderer: "HolidaysDateRenderer",
        }
    },
    {
        pages: [paths.vacationsDetailDebit],
        config: {
            headerName: getLocalizedString("endDate"),
            field: "end_date",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellRenderer: "HolidaysDateRenderer",
        }
    },
    {
        pages: [paths.vacationsDetailDebit],
        config:
        {
            headerName: getLocalizedString("movement"),
            field: "movement",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.vacationsDetailDebit],
        config:
        {
            headerName: getLocalizedString("dailyQuantity"),
            field: "daily_quantity",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacationsDetailDebit],
        config:
        {
            headerName: getLocalizedString("daysQuantity"),
            field: "days_quantity",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.vacationsDetailDebit],
        config:
        {
            headerName: getLocalizedString("comments"),
            field: "comments",
            filter: "agTextColumnFilter",
        }
    },
]